import { endpointsMetadata } from '../routes/endpointsMetadata';
import { DashboardMetrics, MetricDetail } from '../../../types/dashboard';
import { DashboardMetricKey } from '../../enums';

export interface GetMetricsParams {
  startDate: string;
  endDate: string;
}

export interface GetMetricDetailParams {
  metricKey: DashboardMetricKey;
  startDate: string;
  endDate: string;
}

export interface MetricToggleParams {
  metricKey: DashboardMetricKey;
}

export const dashboardApi = {
  getMetrics: {
    endpoint: endpointsMetadata.dashboard.getMetrics,
    buildQueryParams: (params: GetMetricsParams) => ({
      startDate: params.startDate,
      endDate: params.endDate,
    }),
  },

  getMetricDetail: {
    endpoint: endpointsMetadata.dashboard.getMetricDetail,
    buildQueryParams: (params: GetMetricDetailParams) => ({
      metricKey: params.metricKey,
      startDate: params.startDate,
      endDate: params.endDate,
    }),
  },

  disableMetric: {
    endpoint: endpointsMetadata.dashboard.disableMetric,
    buildPayload: (params: MetricToggleParams) => ({
      metricKey: params.metricKey,
    }),
  },

  enableMetric: {
    endpoint: endpointsMetadata.dashboard.enableMetric,
    buildPayload: (params: MetricToggleParams) => ({
      metricKey: params.metricKey,
    }),
  },
};

export interface DashboardMetricsResponse {
  metrics: DashboardMetrics;
  disabledMetrics: DashboardMetricKey[];
}
export type MetricDetailResponse = MetricDetail;